import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
//InvitaTion
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    meta:{
      title:"米粒饭票"
    },
    component: () => import( '../views/HomeContent.vue'),
    children:[
      {
        path: '/home',
        name: 'home',
        meta:{
          title:"米粒饭票"
        },
        component: () => import( '../views/HomeCenter.vue')
      },
      {
        path: '/about',
        name: 'about',
        component: () => import( '../views/HomeAbout.vue')
      },
      {
        path: '/',
        name: 'bwc',
        meta:{
          title:"米粒饭票"
        },
        component: () => import( '../views/HomeBwc.vue')
      },
      {
        path: '/homearr',
        name: 'homearr',
        meta:{
          title:"米粒饭票"
        },
        component: () => import( '../views/HomeView.vue')
      }
    ]
  },
  {
    path: '/InvitaTion',
    name: 'InvitaTion',
    component: () => import( '../views/InvitaTion.vue')
  },
  {
    path: '/RecordList',
    name: 'RecordList',
    component: () => import( '../views/RecordList.vue')
  },
  {
    path: '/myorder',
    name: 'myorder',
    meta:{
      title:"参与明细"
    },
    component: () => import( '../views/MyOrder.vue')
  },
  {
    path: '/elem',
    name: 'elem',
    meta:{
      title:"饿了么红包"
    },
    component: () => import( '../views/EleMo.vue')
  },
  {
    path: '/newpage',
    name: 'newpage',
    meta:{
      title:"消息"
    },
    component: () => import( '../views/NewPage.vue')
  },
  {
    path: '/notice',
    name: 'notice',
    component: () => import( '../views/NoTice.vue')
  },
  {
    path: '/HomeGlue',
    name: 'HomeGlue',
    component: () => import( '../views/HomeGlue.vue')
  },
  {
    path: '/WithDrawal',
    name: 'WithDrawal',
    component: () => import( '../views/WithDrawal.vue')
  },
  {
    path: '/DrawalDetails',
    name: 'DrawalDetails',
    meta:{
      title:"提现明细"
    },
    component: () => import( '../views/DrawalDetails.vue')
  },
  {
    path: '/CommAnder',
    name: 'CommAnder',
    meta:{
      title:"米粒饭票"
    },
    component: () => import( '../views/CommAnder.vue')
  },
  {
    path: '/MyBanner',
    name: 'MyBanner',
    meta:{
      title:"米粒饭票"
    },
    component: () => import( '../views/MyBanner.vue')
  },
  {
    path: '/ListMoney',
    name: 'ListMoney',
    meta:{
      title:"米粒饭票"
    },
    component: () => import( '../views/ListMoney.vue')
  },
  {
    path: '/HomeGlues',
    name: 'HomeGlues',
    component: () => import( '../views/HomeGlues.vue')
  },
  {
    path: '/OrderNumber',
    name: 'OrderNumber',
    component: () => import( '../views/OrderNumber.vue')
  },
  {
    path: '/EleMent',
    name: 'EleMent',
    meta:{
      title:"米粒饭票"
    },
    component: () => import( '../views/EleMent.vue')
  },
  {
    path: '/LikeS',
    name: 'LikeS',
    meta:{
      title:"提交集赞截图"
    },
    component: () => import( '../views/LikeS.vue')
  }
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = String(to.meta.title);
  }
  next()
  })
export default router
